





























import {
  defineComponent,
  useFetch,
  ref,
  useContext
} from '@nuxtjs/composition-api';
import { useCurrency } from '@wemade-vsf/composables';
import { SfDropdown, SfButton } from '@storefront-ui/vue';

export default defineComponent({
  name: 'CurrencySwitcher',
  components: {
    SfDropdown,
    SfButton
  },
  setup () {
    const { app } = useContext();
    const { load, currency, change } = useCurrency();
    const isOpen = ref(false);

    const currentCurrency = ref(app.$vsf.$magento.config.state.getCurrency());
    const otherCurrencies = ref<string[]>([]);

    useFetch(async() => {
      if (!currency.value.available_currency_codes) {
        await load();
      }
      if (!currentCurrency.value) {
        currentCurrency.value = currency.value.default_display_currency_code ?? '';
      }
      // @ts-ignore
      otherCurrencies.value = currency.value.available_currency_codes?.filter((code: string | null) => code && (code !== currentCurrency.value)) ?? [];
    });

    return {
      currentCurrency,
      otherCurrencies,
      isOpen,
      change
    }
  }
})
